import React, { useMemo } from "react";
import Table from "../../../components/Table";
import TitleButtons from "../../../components/TitleButtons";
import { useEmpresasCliente } from "./empresasCadastradasData";
import { useNavigate } from "react-router-dom";

type Cliente = {
  cnpj: string;
  razao_social: string;
  nome_fantasia: string;
  responsaveis_nomes?: string[] | null;
};

type Row = React.ReactNode[];

function onlyDigits(s: string) {
  return String(s || "").replace(/\D+/g, "");
}

function formatCNPJ(cnpj: string) {
  const d = onlyDigits(cnpj).padStart(14, "0").slice(-14);
  return d.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
}

function normalizeClientes(raw: any): Cliente[] {
  if (!raw) return [];
  const arr = Array.isArray(raw)
    ? raw
    : Array.isArray(raw?.data)
    ? raw.data
    : [];

  return (arr as any[]).map((x) => ({
    cnpj: x.cnpj ?? x.CNPJ ?? "",
    razao_social:
      x.razao_social ?? x.razaoSocial ?? x.razao ?? x.razao_social_nome ?? "",
    nome_fantasia:
      x.nome_fantasia ?? x.nomeFantasia ?? x.fantasia ?? x.nome ?? "",
    responsaveis_nomes: Array.isArray(x.responsaveis_nomes)
      ? x.responsaveis_nomes
      : Array.isArray(x.responsaveisNomes)
      ? x.responsaveisNomes
      : [],
  }));
}

function formatResponsaveis(nomes?: string[] | null) {
  const list = (nomes || []).map((n) => String(n || "").trim()).filter(Boolean);
  return list.length ? list.join(", ") : "-";
}

const EmpresasClientes: React.FC = () => {
  const headers = useMemo(
    () => ["CNPJ", "Razão Social", "Nome Fantasia", "Coordenador Responsável"],
    []
  );

  const columnWidths = useMemo(() => ["180px", "360px", "300px", "320px"], []);

  const hook = useEmpresasCliente?.();
  const data = normalizeClientes((hook as any)?.data ?? hook);

  const rows: Row[] = useMemo(() => {
    return data.map((c) => [
      formatCNPJ(c.cnpj || ""),
      c.razao_social || "-",
      c.nome_fantasia || "-",
      formatResponsaveis(c.responsaveis_nomes),
    ]);
  }, [data]);

  const navigate = useNavigate();

  return (
    <div>
      <TitleButtons
        title="Recursos Humanos - Empresas/clientes"
        buttons={[
          {
            label: "Registrar Empresa",
            onClick: () =>
              navigate(
                "/recursos-humanos/empresas-cadastradas/registrar-empresa"
              ),
            variant: "primary",
          },
        ]}
      />

      <Table
        headers={headers}
        rows={rows}
        columnWidths={columnWidths}
        responsiveWidths={{
          // índices 0..3: 0 CNPJ, 1 Razão Social, 2 Nome Fantasia, 3 Coordenador Responsável
          1300: {
            1: "300px",
            2: "240px",
            3: "280px",
          },
          1000: {
            0: "160px",
            1: "240px",
            2: "0px", // se quiser esconder Nome Fantasia no mobile
            3: "260px", // mantém Coordenador visível
          },
        }}
      />
    </div>
  );
};

export default EmpresasClientes;
